<template>
    <div v-if="activeView === 'intro'"
         id="intro-content"
         class="row d-flex justify-content-center"
    >
        <div class="col-12 col-md-9 text-center">
            <div
                class="text-primary font-size-28 me-1"
                :class="['icon', dto.introContent.icon]"
                aria-hidden="true"
            />
            <div>
                <p
                    class="h4 fw-bold"
                    v-html="dto.introContent.title"
                />
                <p
                    class="lead mb-0 py-0"
                    v-html="dto.introContent.text"
                />
            </div>
        </div>
        <div class="col-12 col-md-9 pt-1">
            <Bouton
                id="add-offer"
                class="w-100 mw-100"
                :is-button="true"
                :is-primary="false"
                :label="dto.introContent.addButton.label"
                :href="dto.introContent.addButton.href"
                :tms-category="dto.introContent.addButton.tms.category"
                :tms-action="dto.introContent.addButton.tms.action"
                :tms-label="dto.introContent.addButton.tms.label"
                @click="onAddOfferClick"
            />
        </div>
        <div class="col-12 col-md-9 pt-1">
            <Bouton
                id="show-form"
                class="w-100 mw-100"
                :is-button="true"
                :is-primary="false"
                :label="dto.introContent.formButton.label"
                :href="dto.introContent.formButton.href"
                :tms-category="dto.introContent.formButton.tms.category"
                :tms-action="dto.introContent.formButton.tms.action"
                :tms-label="dto.introContent.formButton.tms.label"
                @click="onShowFormClick"
            />
        </div>
        <div
            v-if="enableContinueWithoutDiscount && dto.introContent.continueWithoutDiscountButton"
            class="d-flex justify-content-center pt-1"
        >
            <a
                id="continue-without-discount"
                class="ob1-link ob1-link-arrow"
                :href="dto.introContent.continueWithoutDiscountButton.href"
                :data-oevent-category="dto.introContent.continueWithoutDiscountButton.tms.category"
                :data-oevent-action="dto.introContent.continueWithoutDiscountButton.tms.action"
                :data-oevent-label="dto.introContent.continueWithoutDiscountButton.tms.label"
                @click="onContinueWithoutDiscountClick"
                v-text="dto.introContent.continueWithoutDiscountButton.label"
            />
        </div>
    </div>
</template>

<script lang="ts">
import {PropType} from "vue";
import {InternetDiscountPopinDto} from "../../cart/models/InternetDiscountPopinDto";
import Bouton from "../ob1/Bouton.vue";

export default {
    name: "DiscountPopinIntroShared",
    components: {
        Bouton
    },
    props: {
        activeView: {
            type: String,
            required: true
        },
        dto: {
            type: Object as PropType<InternetDiscountPopinDto>,
            required: true
        },
        emitAddOfferClick: {
            type: Boolean,
            required: false,
            default: false
        },
        enableContinueWithoutDiscount: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        onAddOfferClick() {
            const redirectUrl = this.dto.introContent.addButton.href;
            if (!redirectUrl) {
                return;
            }
            if (this.emitAddOfferClick) {
                this.$emit('add-offer-click', redirectUrl);
                return;
            }
            window.location.href = redirectUrl;
        },
        onShowFormClick() {
            this.$emit('update:activeView', 'form');
        },
        onContinueWithoutDiscountClick(event: Event) {
            if (event) {
                event.preventDefault();
            }
            const redirectUrl = this.dto.introContent.continueWithoutDiscountButton
                && this.dto.introContent.continueWithoutDiscountButton.href;
            if (redirectUrl) {
                this.$emit('continue-without-discount-click', redirectUrl);
            }
        }
    }
}
</script>
